<template>
  <div>
    <BaseHeadline
      icon="mdi-clipboard-alert-outline"
      :subtitle="`Sist oppdatert ${data.updatedString}`"
    >
      <template v-slot:headlineBtns>
        <v-btn
          v-if="isResponsible && !isTrysilhus && !isDone"
          class="mb-0 mr-2"
          color="primary"
          depressed
          @click="showChangeStatusToDoneDialog = true"
        >
          <v-icon left>mdi-check-circle-outline</v-icon>
          Ferdigstill
        </v-btn>
        <v-btn
          v-if="isResponsible && isTrysilhus"
          class="mb-0 mr-2"
          color="primary"
          depressed
          @click="showChangeStatusDialog = true"
        >
          <v-icon left>mdi-autorenew</v-icon>
          Endre status
        </v-btn>
        <v-btn
          v-if="isResponsible"
          color="primary"
          depressed
          @click="showChangeResponsiblyDialog = true"
        >
          <v-icon left>mdi-account-outline</v-icon>
          Endre ansvarllig
        </v-btn>
      </template>
    </BaseHeadline>

    <ButtonGroup
      class="my-3"
      v-if="$vuetify.breakpoint.smAndDown && isResponsible"
      v-model="buttons"
      @changeResponsibly="showChangeResponsiblyDialog = true"
      @changeStatus="showChangeStatusDialog = true"
      @changeStatusToDone="showChangeStatusToDoneDialog = true"
    />

    <BaseView v-model="list">
      <template v-slot="{ element }">
        <ComplaintInfoCard
          v-if="element.type === 'ComplaintInfoCard'"
          v-model="data"
          :loading="loading"
        />
        <!-- <ComplaintFloorplanCard
          v-if="element.type === 'ComplaintFloorplanCard'"
        /> -->
        <ComplaintLocationCard
          v-if="element.type === 'ComplaintLocationCard'"
          v-model="regLineLocation"
          :loading="loading"
        />
        <ComplaintUserCard
          v-if="element.type === 'ComplaintUserCard'"
          v-model="regLineCustomer"
          :loading="loading"
        />
        <!-- <Attachments v-if="element.type === 'Attachments'"></Attachments> -->
        <Attachments
          v-if="element.type === 'Attachments' && data.attachments"
          v-model="data.attachments"
          @change="attachmentsAdded"
        ></Attachments>
        <!-- <Comments v-if="element.type === 'Comments'" /> -->
        <Comments
          ref="comments"
          v-if="element.type === 'Comments'"
          :context="commentsType"
          :tagUsers="tagUsers"
          @comments="getComments"
        />
      </template>
    </BaseView>
    <!-- <ChangeResponsiblyDialog v-model="showChangeResponsiblyDialog" /> -->
    <ChangeResponsiblyDialog
      v-model="showChangeResponsiblyDialog"
      :responsible="data.contactPersonPersonFullName"
      :items="responsibleItems"
      @save="changeResponsible"
    />

    <ChangeStatusDialog
      v-model="showChangeStatusDialog"
      :statusId="data.lineStatus"
      :statusString="data.regStatus"
      :statuses="regStatusesList"
      @save="changeStatus"
    />
    <ChangeStatusToDoneDialog
      v-model="showChangeStatusToDoneDialog"
      @save="changeStatus"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import { valueTypeObject } from "@/types/commentInterface";
import { FilterBtnObject } from "@/types/interface";
import { KeyValueExtra } from "@/types/keyValue";
import { CommentType } from "@/enums/enums";
import complaintApi from "@/api/complaintApi";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import ButtonGroup from "@/components/shared/buttons/ButtonGroup.vue";

import BaseView from "@/components/shared/BaseView.vue";
import ComplaintInfoCard from "@/components/complaints/complaint/ComplaintInfoCard.vue";
// import ComplaintFloorplanCard from "@/components/complaints/complaint/ComplaintFloorplanCard.vue";
import ComplaintLocationCard from "@/components/complaints/complaint/ComplaintLocationCard.vue";
import ComplaintUserCard from "@/components/complaints/complaint/ComplaintUserCard.vue";
import Comments from "@/components/shared/comments/Commens.vue";
import Attachments from "@/components/shared/attachments/Attachments.vue";
import ChangeResponsiblyDialog from "@/components/shared/dialog/ChangeResponsiblyDialog.vue";
import ChangeStatusDialog from "@/components/shared/dialog/ChangeStatusDialog.vue";
import ChangeStatusToDoneDialog from "@/components/complaints/complaint/children/ChangeStatusToDoneDialog.vue";

export default Vue.extend({
  data() {
    return {
      data: {} as any,
      regLineLocation: {} as any,
      regLineCustomer: {} as any,
      regStatuses: [] as Array<KeyValueExtra>,
      tagUsers: [] as Array<KeyValueExtra>,
      responsibleItems: null as any,
      loading: false,
      commentsType: {} as valueTypeObject,
      comments: null as any,
      showChangeResponsiblyDialog: false,
      showChangeStatusDialog: false,
      showChangeStatusToDoneDialog: false,
      list: {
        lg: [
          [{ type: "ComplaintInfoCard" }],
          // [{ type: "ComplaintFloorplanCard" }],
          [{ type: "ComplaintLocationCard" }, { type: "ComplaintUserCard" }],
          [{ type: "Attachments" }, { type: "Comments" }],
        ],
        md: [
          [{ type: "ComplaintInfoCard" }],
          [
            // { type: "ComplaintFloorplanCard" },
            { type: "ComplaintLocationCard" },
            { type: "ComplaintUserCard" },
          ],
          [{ type: "Attachments" }, { type: "Comments" }],
        ],
        sm: [
          [
            { type: "ComplaintInfoCard" },
            // { type: "ComplaintFloorplanCard" },
            { type: "ComplaintLocationCard" },
            { type: "ComplaintUserCard" },
          ],
          [{ type: "Attachments" }, { type: "Comments" }],
        ],
        xs: [
          [
            { type: "ComplaintInfoCard" },
            // { type: "ComplaintFloorplanCard" },
            { type: "ComplaintLocationCard" },
            { type: "ComplaintUserCard" },
            { type: "Attachments" },
            { type: "Comments" },
          ],
        ],
      },
    };
  },
  async mounted() {
    this.loading = true;

    var id = parseInt(this.$route.params.id);

    await complaintApi.getComplaintDetails(id).then((response) => {
      this.data = response.regLine;
      this.regLineLocation = response.regLine.regLineLocation;
      this.regLineCustomer = response.regLine.regLineCustomer;
      this.regStatuses = response.regStatuses;
      this.tagUsers = response.tagUsers;

      if (!this.profile.isTrysilhus) {
        this.responsibleItems = response.contactPersons.filter((x) => {
          return x.key !== response.regLine.contactPersonId;
        });
      }

      this.loading = false;
      this.commentsType.id = id;
      this.commentsType.commentType = CommentType.RegLine;
      this.commentsType.lineStatus = response.regLine.lineStatus;

      (this as any).$refs?.comments?.getComments(this.commentsType);
    });
  },
  methods: {
    async save() {
      // this.data.lineStatus = this.data.lineStatus === 0 ? 1 : 0;
      await complaintApi.updateComplaint(this.data).then((response) => {
        this.data = response.regLine;
        (this as any).$refs.comments.getComments(this.commentsType);
      });
    },
    async changeStatus({ comment, newStatus }) {
      //When close dialog newComment is deleted. This wil save it
      comment.text = comment.newComment;

      this.data.comments.push(comment);
      this.data.lineStatus = newStatus;

      await this.save();
    },
    async changeResponsible(newResponsibleId, contactId) {
      this.data.contactPersonId = newResponsibleId;
      if (this.profile.isTrysilhus && contactId) {
        this.data.contactId = contactId;
      } else if (!this.profile.isTrysilhus) {
        this.data.contactId = this.profile.contact.id;
      }

      await this.save();
      this.showChangeResponsiblyDialog = false;
    },
    async attachmentsAdded() {
      await this.save();
    },
    getComments(comments) {
      this.comments = comments;
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      isMainContactPerson: "shared/isMainContactPerson",
    }),
    isResponsible() {
      if (
        (!this.isTrysilhus && this.isMainContactPerson) ||
        this.profile?.id === this.data?.contactPersonId
      ) {
        return true;
      }
      return false;
    },
    isDone() {
      switch (this.data?.lineStatus) {
        case 2:
        case 3:
        case 5: {
          return true;
        }
        default:
          return false;
      }
    },
    buttons(): Array<FilterBtnObject> {
      var buttons = [
        {
          show:
            this.isResponsible && !this.isTrysilhus && !this.isDone
              ? true
              : false,
          name: "Ferdigstill",
          color: "primary",
          emit: "changeStatusToDone",
          icon: "mdi-checkbox-marked-circle-outline",
        },
        {
          show: this.isTrysilhus ? true : false,
          name: "Endre status",
          color: "primary",
          emit: "changeStatus",
          icon: "mdi-autorenew",
        },
        {
          show: true,
          name: "Endre ansvarlig",
          color: "primary",
          emit: "changeResponsibly",
          icon: "mdi-account-outline",
        },
      ];

      return buttons;
    },
    regStatusesList(): Array<KeyValueExtra> {
      //Remove disabled from list
      return this.regStatuses.filter((x) => x.attr1 !== "disabled");
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    ButtonGroup,
    ComplaintInfoCard,
    // ComplaintFloorplanCard,
    ComplaintLocationCard,
    ComplaintUserCard,
    Comments,
    Attachments,
    ChangeResponsiblyDialog,
    ChangeStatusDialog,
    ChangeStatusToDoneDialog,
  },
});
</script>
